import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ToasterService } from 'angular2-toaster';
import { JobOffersService } from 'app/services';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import * as moment from 'moment';
import { DP_FORMAT, MAX_EXP_GG } from 'app/views/jobOffers/edit-join-offer/exports';

@Component({
  selector: 'app-update-expiry-date-button',
  templateUrl: './update-expiry-date-button.component.html',
  styleUrls: ['./update-expiry-date-button.component.scss']
})
export class UpdateExpiryDateButtonComponent implements OnInit {
  @Input() id: number;
  @Input() type: 'button' | 'icon' = 'button';
  @Input() state: 'published' | 'processing' | 'paused' = 'paused';

  @ViewChild('template') template: TemplateRef<any>;

  modalRef: BsModalRef;
  public form: FormGroup = new FormGroup({});
  model: any = {
    showErrorState: true,
    isLoading: false,
  };
  public fields: FormlyFieldConfig[] = [];

  public get hasMktgPlan(): boolean {
    return (
      JSON.parse(localStorage.getItem("userData")).plan &&
      JSON.parse(localStorage.getItem("userData")).plan === 'marketing'
    );
  }

  constructor(
    private jos: JobOffersService,
    private router: Router,
    private toaster: ToasterService,
    private modalService: BsModalService
  ) { }

  async ngOnInit() {
  }

  async updateExpirationDate(): Promise<void> {
    switch (this.state) {
      // case 'processing':
      case 'published': {
        this.openModal();
        break;
      }
      case 'processing':
      case 'paused': {
        this.toaster.pop('error', `You can't update a job offer in ${this.state} state.`);
        break;
      }
      default:
        return;
    }
  }

  async openModal() {
    const expDate = { ...await this.jos.retrieve(this.id).toPromise() }.expiration_date;
    this.fields = [
      {
        key: "expiration_date",
        type: "date",
        defaultValue: expDate || moment().add(1, 'days').format(DP_FORMAT),
        // moment('2022-01-01').format(DP_FORMAT) || expDate,
        validation: {
          show: true,
        },
        expressionProperties: {
          'validation.show': 'model.showErrorState',
        },
        templateOptions: {
          label: "Expiration Date",
          /* eslint-disable */
          /* @ts-ignore */
          _min: moment().add(1, 'days').format(DP_FORMAT),
          /* @ts-ignore */
          ...(!this.hasMktgPlan && { _max: moment().add(MAX_EXP_GG, 'days').format(DP_FORMAT) }),
          /* eslint-enable */
          required: true,
          config: {
            format: DP_FORMAT,
          },
          // disabled: this.isFieldDisabled,

          // type: "text",
          // datepickerPopup: "dd-MMMM-yyyy",
        },
        validators: {
          ip: {
            expression: (c) => {
              return moment(c.value).isSameOrAfter(moment().add(1, 'days').format(DP_FORMAT))
            },
            message: (error, field: FormlyFieldConfig) => `${field.formControl.value} must be grater then today`,
          },
        },
      },
      {
        key: "submit",
        type: "submit",
        templateOptions: {
          buttonLabel: "Save",
          form: this.form,
          className: "btn btn-success btn-block",
        },
        expressionProperties: {
          'templateOptions.disabled': 'model.isLoading',
        },
      },
    ];
    this.modalRef = this.modalService.show(this.template);
  }

  modalClose() {
    this.modalRef.hide();
    this.form.reset();
  }

  public async onSubmit(model: any) {
    // this.isLoading = true;
    this.model.isLoading = true;
    const { expiration_date } = model;
    await this.jos.updateExpirationDate(this.id, expiration_date).toPromise();
    this.modalClose();
    this.model.isLoading = false;
    this.toaster.pop('success', `Job Updated successfully.`);
    this.router.navigate(['/recruiting']);
  }

  // this.toaster.pop('success', `Job closed successfully.`);

  // await this.jos.updateState(this.id).toPromise();
  // // FIX-ME toaster
  // this.router.navigate(['/recruiting']);

}
